import React from 'react';
import Table, {SortDir} from "../deprecatedUikit/Table/Table";
import ActionButtons from './subComponents/ActionButtons';
import CorrectionStatusBar from './subComponents/CorrectionStatusBar';
import type {GroupedLocationInventoryActivity} from "../../types/GroupedLocationInventoryActivity";

interface HeadCell {
  id: string;
  label: string;
}

const inventoryRecordsHeadCells: HeadCell[] = [
  {'id': 'containerNumber', 'label': 'CONTAINER NUMBER'},
  {'id': 'chassisNumber', 'label': 'CHASSIS NUMBER'},
  {'id': 'trailerNumber', 'label': 'TRAILER NUMBER'},
  {'id': 'truckLicensePlateNumber', 'label': 'TRUCK LICENSE PLATE NUMBER'},
  {'id': 'checkinDate', 'label': 'CHECKIN ACTIVITY'},
  {'id': 'checkoutDate', 'label': 'CHECKOUT ACTIVITY'},
];

interface InventoryRecordsTableProps {
  inventoryRecords: GroupedLocationInventoryActivity[];
  isLoading: boolean;
  setInventory: (inventory: GroupedLocationInventoryActivity) => void;
  deleteCorrection: (id: string) => void;
  handleSortChange: (column: string, order: SortDir) => void;
  sortBy?: string;
  sortDir?: SortDir;
}

const InventoryRecordsTable = ({
                                 inventoryRecords,
                                 isLoading,
                                 setInventory,
                                 deleteCorrection,
                                 handleSortChange,
                                 sortBy = "",
                                 sortDir = "desc"
                               }: InventoryRecordsTableProps) => {
  const actionButtons = ({item}: { item: GroupedLocationInventoryActivity }) =>
    <ActionButtons
      item={item}
      setInventory={setInventory}
      deleteCorrection={deleteCorrection}
    />;

  const correctionStatusBar = ({item}: { item: GroupedLocationInventoryActivity }) =>
    <CorrectionStatusBar
      item={item}
    />;

  return (
    <Table
      actionType={'button'}
      headCells={inventoryRecordsHeadCells}
      rows={inventoryRecords}
      isLoading={isLoading}
      isShadow={true}
      actionButtons={actionButtons}
      hasRowAction={true}
      RowSubComponent={correctionStatusBar}
      isSortable={true}
      handleSortRequest={handleSortChange}
      sortBy={sortBy}
      sortDir={sortDir}
    />
  );
}

export default InventoryRecordsTable;
